// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageOnly_container__7xOWW","images":"ImageOnly_images__k2Zru","image_wrapper":"ImageOnly_image_wrapper__HVW7e"};